<template>
    <a class="k-card-course" :href="course.url">
        <div class="cover">
            <img :src="course.imgUrl">
        </div>
        <div class="title">
            {{course.title}}
        </div>
    </a>
</template>

<style lang="less" scoped>
.k-card-course {
    display: inline-block;
    width: 2.72rem;
    height: 3.82rem;
    border-radius: .08rem;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
    padding-top: .34rem;
    margin: 2px 0 2px 0;
    margin-left: .17rem;
    color: black;
    vertical-align: top;
    .cover {
        width: 2.4rem;
        height: 2.46rem;
        margin: 0 auto;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .title {
        font-size: .28rem;
        line-height: .4rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 2.4rem;
        margin: .14rem auto 0;
        text-align: left;
    }
}
</style>

<script>
export default {
    name: 'k-card-course',
    props: ['course']
}
</script>
